import { IconLogout, IconRefresh } from '@tabler/icons-react';
import { Select } from '@mantine/core';

type OrgOption = {
  orgId: string;
  orgName: string;
};

type NoPaymentOrgEscapeHatchProps = {
  activeOrgId?: string;
  isSwitching: boolean;
  orgs?: OrgOption[];
  selectedOrgId: string | null;
  onSelectedOrgChange: (value: string | null) => void;
  onSwitchOrg: () => void;
  onLogout: () => void;
};

export function NoPaymentOrgEscapeHatch({
  activeOrgId,
  isSwitching,
  orgs,
  selectedOrgId,
  onSelectedOrgChange,
  onSwitchOrg,
  onLogout,
}: NoPaymentOrgEscapeHatchProps) {
  return (
    <div className="flex w-full flex-wrap items-center justify-center gap-x-2 gap-y-2 text-zinc-500 dark:text-zinc-400">
      {orgs && orgs.length > 0 && (
        <>
          <Select
            className="min-w-[220px] sm:w-[260px]"
            placeholder="Select organization"
            value={selectedOrgId}
            onChange={onSelectedOrgChange}
            data={orgs.map((org) => ({
              value: org.orgId,
              label: org.orgId === activeOrgId ? `${org.orgName} (current)` : org.orgName,
            }))}
            aria-label="Organization"
            size="xs"
            searchable
            comboboxProps={{ withinPortal: true, zIndex: 400 }}
          />
          <button
            type="button"
            disabled={!selectedOrgId || selectedOrgId === activeOrgId || isSwitching}
            onClick={onSwitchOrg}
            className="inline-flex h-8 items-center justify-center gap-2 rounded-md border border-zinc-300 bg-white px-3 text-sm font-medium text-zinc-700 transition-colors hover:bg-zinc-100 focus-visible:ring-1 focus-visible:ring-zinc-950 focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 dark:border-zinc-700 dark:bg-zinc-950 dark:text-zinc-200 dark:hover:bg-zinc-900 dark:focus-visible:ring-zinc-300"
          >
            <IconRefresh size={14} />
            Switch org
          </button>
          <span className="hidden text-zinc-300 sm:inline dark:text-zinc-700">|</span>
        </>
      )}
      <button
        type="button"
        onClick={onLogout}
        className="inline-flex items-center gap-1 text-sm transition-colors hover:text-zinc-900 hover:underline hover:underline-offset-4 dark:hover:text-zinc-50"
      >
        <IconLogout size={14} />
        Switch Account
      </button>
    </div>
  );
}
